import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'

import HierarchySelect from 'component/hierarchy/HierarchySelect'

const FIELDS = [
  'sectionId',
  'subSectionId',
  'typeId',
  'subTypeId',
  'idDatasheetFormatList',
  'sectionIdDescription',
  'subSectionIdDescription',
  'typeIdDescription',
  'subTypeIdDescription',
]

const DatasheetManagementForm = (props) => {
  const {
    datasheetFormatList,
    fields,
    handleSave,
    resetForm,
    setValueToField,
    translate,
    user,
    values,
  } = props

  const beforeHandleSave = (event) => {
    event.preventDefault()

    handleSave(values)

    resetForm()
  }

  const handleChange = (field, value, remove, description) => {
    setValueToField(field, value)
    setValueToField(`${field}Description`, description)

    remove.forEach((item) => setValueToField(item, ''))
  }

  const datasheetFormatOptions = datasheetFormatList.map((df) => ({
    value: df.idDatasheetFormat,
    label: df.nmDatasheetFormat,
  }))

  const disableSubmitButton = () =>
    !values.sectionId || !values.idDatasheetFormatList.length

  const hierarchySelectDefaultProps = {
    concatId: true,
    isClearable: true,
    placeholder: '',
    translate,
    user,
  }

  return (
    <form onSubmit={beforeHandleSave}>
      <Col xs={12} md={2}>
        <Field
          {...fields.sectionId}
          hint={translate('mobile.punctual.adjust.sectionBlock.section')}
        >
          <HierarchySelect
            {...hierarchySelectDefaultProps}
            name='sectionId'
            onChange={(option) =>
              handleChange(
                'sectionId',
                option.value,
                ['subSectionId', 'typeId', 'subTypeId'],
                option.label
              )
            }
            query={{ level: 2 }}
            value={values.sectionId}
          />
        </Field>
      </Col>

      <Col xs={12} md={2}>
        <Field
          {...fields.subSectionId}
          hint={translate('mobile.punctual.adjust.sectionBlock.subSection')}
        >
          <HierarchySelect
            {...hierarchySelectDefaultProps}
            field='subSectionId'
            name='subSectionId'
            noOptions={!values.sectionId}
            onChange={(option) =>
              handleChange(
                'subSectionId',
                option.value,
                ['typeId', 'subTypeId'],
                option.label
              )
            }
            query={{ level: 3, sectionId: values.sectionId }}
            value={values.subSectionId}
          />
        </Field>
      </Col>

      <Col xs={12} md={2}>
        <Field
          {...fields.typeId}
          hint={translate('mobile.punctual.adjust.sectionBlock.type')}
        >
          <HierarchySelect
            {...hierarchySelectDefaultProps}
            field='typeId'
            name='typeId'
            noOptions={!values.subSectionId}
            onChange={(option) =>
              handleChange('typeId', option.value, ['subTypeId'], option.label)
            }
            query={{
              level: 4,
              sectionId: values.sectionId,
              subSectionId: values.subSectionId,
            }}
            value={values.typeId}
          />
        </Field>
      </Col>

      <Col xs={12} md={2}>
        <Field
          {...fields.subTypeId}
          hint={translate('mobile.punctual.adjust.sectionBlock.subType')}
        >
          <HierarchySelect
            {...hierarchySelectDefaultProps}
            field='subTypeId'
            name='subTypeId'
            noOptions={!values.typeId}
            onChange={(option) =>
              handleChange('subTypeId', option.value, [], option.label)
            }
            query={{
              level: 5,
              sectionId: values.sectionId,
              subSectionId: values.subSectionId,
              typeId: values.typeId,
            }}
            value={values.subTypeId}
          />
        </Field>
      </Col>

      <Col xs={12} md={2}>
        <Field
          {...fields.idDatasheetFormatList}
          hint={translate('datasheetManagement.format')}
        >
          <Select
            className='react-select'
            classNamePrefix='react-select'
            closeMenuOnSelect={false}
            isMulti
            name='idDatasheetFormatList'
            onChange={(options) =>
              setValueToField(
                'idDatasheetFormatList',
                options ? options.map((option) => option.value) : []
              )
            }
            options={datasheetFormatOptions}
            placeholder=''
            value={datasheetFormatOptions.filter((option) =>
              values.idDatasheetFormatList.some(
                (value) => option.value === value
              )
            )}
          />
        </Field>
      </Col>

      <Col xs={12} md={2}>
        <button
          disabled={disableSubmitButton()}
          className='button button-primary button-full margin-top'
        >
          {translate('register_button')}
        </button>
      </Col>
    </form>
  )
}

DatasheetManagementForm.propTypes = {
  datasheetFormatList: PropTypes.array.isRequired,
  fields: PropTypes.object.isRequired,
  handleSave: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
}

export default Form({ fields: FIELDS })(DatasheetManagementForm)

export { DatasheetManagementForm }
